module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-08.0d54a7b8.png";